import { useBalance } from "./BalanceContext";
import { useIncomingInvoice } from "./IncomingInvoiceContext";
import { useLedger } from "./LedgerContext";
import { useReport } from "./ReportContext";

// Custom hook to clear the state of BusinessContext
export const useRefreshTrans = () => {
  
  const { getRecentLedgers } = useLedger();
  const {refresh: refreshBalances} = useBalance();
  const {refresh: refreshReports} = useReport();
  const {refresh: refreshIncomingInvoices}  = useIncomingInvoice();



  // Function to clear the state
  const refreshTransactions = () => {
    getRecentLedgers(true)
    refreshBalances();
    refreshReports();
    refreshIncomingInvoices();
  };

  return refreshTransactions;
};
